import React from 'react';
import './PrivateLayout.css';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { AppHeader } from './Header.jsx';
import { AppMobileSidebar, AppSidebar, } from './Sidebar.jsx';
import { AppFooter } from './Footer.jsx';
import { styled } from '@mui/material';
import { useIsOnMobile } from '../../hooks/layoutHooks.js';

const AppContainer = styled(Box)(({ theme }) => ({
    height: "100vh",
    width: "100vw",
    display: "flex"
}));

const AppBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    overflow: "hidden",
    paddingTop: theme.spacing(8),
    [theme.breakpoints.down("sm")]: {
        paddingTop: theme.spacing(7),
    }
}));

const AppMain = styled(Box)(({ theme }) => ({
    height: "100%",
    width: "100%",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
}));


const PrivateLayout = (props) => {
    const [openSidebar, setOpenSidebar] = React.useState(false);

    const handleDrawerToggle = () => {
        setOpenSidebar(state => !state);
    };

    const handleDrawerClose = () => {
        setOpenSidebar(false);
    };

    const isMobile = useIsOnMobile()
    if (isMobile) {
        return <PrivateLayoutMobile {...props} openSidebar={openSidebar} handleDrawerToggle={handleDrawerToggle} handleDrawerClose={handleDrawerClose} />
    } else {
        return <PrivateLayoutDesktop {...props} openSidebar={openSidebar} handleDrawerToggle={handleDrawerToggle} handleDrawerClose={handleDrawerClose} />
    }
};

const PrivateLayoutDesktop = ({ children, openSidebar, handleDrawerToggle, handleDrawerClose }) => {
    return (
        <AppContainer>
            <CssBaseline />
            {/* Header */}
            <AppHeader open={openSidebar} handleDrawerToggle={handleDrawerToggle} />
            {/* SideBar */}
            <AppSidebar open={openSidebar} handleDrawerClose={handleDrawerClose} />
            {/* Main Side  */}
            <AppBox component="main" className='mainSide'>
                {/* <AppBarSpacer /> */}
                <AppMain className="contentSide">
                    <Box sx={{ flex: 1, overflow: "auto" }}>
                        {children}
                    </Box>
                    <AppFooter />
                </AppMain>
            </AppBox>

        </AppContainer>
    );
};

const AppContainerForMobile = styled(Box)(({ theme }) => ({
    minHeight: "100vh",
    width: "100vw",
    display: "flex",
    flexDirection: "column",
    paddingTop: theme.spacing(8),
    [theme.breakpoints.down("sm")]: {
        paddingTop: theme.spacing(7),
    }
}));



const PrivateLayoutMobile = ({ children, openSidebar, handleDrawerToggle, handleDrawerClose }) => {
    return (
        <>
            <AppContainerForMobile>
                <CssBaseline />
                {/* Header */}
                <AppHeader open={openSidebar} handleDrawerToggle={handleDrawerToggle} />
                {/* Main Side */}
                <Box sx={{ flex: 1, overflow: "auto" }}>
                    {children}
                </Box>
                <AppFooter />
            </AppContainerForMobile>
            {/* SideBar */}
            <AppMobileSidebar open={openSidebar} handleDrawerClose={handleDrawerClose} />
        </>
    );
};

export default PrivateLayout;